import React, { useState } from 'react';
import { Image } from 'cloudinary-react';

const HotelPhotoUpload = ({ setImageUrls }) => {
  const [selectedPhotos, setSelectedPhotos] = useState([]);

  const cloudName = 'major-hotel'; // Replace with your Cloudinary cloud name
  const uploadPreset = 'image-upload-preset'; // Replace with your Cloudinary upload preset name
  const deleteToken = 'YOUR_DELETE_TOKEN'; // Replace with your Cloudinary delete token

  const handleUpload = (event) => {
    const files = event.target.files;
    const uploadedPhotos = [];

    for (let i = 0; i < files.length; i++) {
      const formData = new FormData();
      formData.append('file', files[i]);
      formData.append('upload_preset', uploadPreset);
    //   formData.append('transformation', 'w_500,h_500,c_fill');

      // Make a POST request to Cloudinary's upload API for each file
      fetch(`https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, {
        method: 'POST',
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          uploadedPhotos.push(data.public_id);
          if (uploadedPhotos.length === files.length) {
            // All photos uploaded, do something with the public_ids (e.g., save them to the database)
            // const imageUrl = `https://res.cloudinary.com/${cloudName}/image/upload/${uploadedPhotos[0]}`; // Assuming only one photo is uploaded
            const imageUrls = uploadedPhotos.map(
          (publicId) => `https://res.cloudinary.com/${cloudName}/image/upload/w_500,h_500/${publicId}`);
            setImageUrls(imageUrls);
            console.log(imageUrls);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const handleRemove = (publicId) => {
    // Remove the photo from Cloudinary
    fetch(`https://api.cloudinary.com/v1_1/${cloudName}/delete_by_token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        public_ids: [publicId],
        token: deleteToken,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        // Handle the response or update your state/database accordingly
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <div>
      <input type="file" accept="image/*" multiple onChange={handleUpload} />
      {selectedPhotos.map((publicId) => (
        <div key={publicId}>
          <Image
            cloudName={cloudName}
            publicId={publicId}
            width="300"
            crop="scale"
          />
          <button onClick={() => handleRemove(publicId)}>Remove</button>
        </div>
      ))}
    </div>
  );
};

export default HotelPhotoUpload;
